var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.className},[(_vm.className == 'loading')?_c('div',{staticClass:"lds-ripple"},[_c('div'),_c('div')]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }